import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useLang } from "../context/I18nContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-20 border-t border-white/10 bg-[#0A1F38]" data-testid="site-footer">
      <div className="site-container py-16 grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-14">
        {/* Brand column */}
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <Logo size="md"/>
            <div className="leading-tight">
              <div className="font-display font-bold text-base tracking-[0.08em] text-white">ECO Haustechnik</div>
              <div className="text-[9px] mt-0.5 tracking-[0.3em] uppercase text-[#5FA637] font-semibold">ECO BUILDING</div>
            </div>
          </div>
          <p className="text-white/60 text-sm max-w-md leading-relaxed">
            {t("footer.companyDesc")}
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-7 text-[11px] tracking-[0.15em] uppercase text-white/40 font-medium">
            <span>{t("footer.tag.a")}</span>
            <span className="text-white/20">·</span>
            <span>{t("footer.tag.b")}</span>
            <span className="text-white/20">·</span>
            <span>{t("footer.tag.c")}</span>
            <span className="text-white/20">·</span>
            <span>{t("footer.tag.d")}</span>
          </div>
        </div>

        {/* Navigation column */}
        <div className="md:col-span-3">
          <div className="eyebrow mb-5">{t("footer.navigation")}</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.start")}</Link></li>
            <li><Link to="/planung-bim" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.planungBim")}</Link></li>
            <li><Link to="/energie-heizung" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.energyHeat")}</Link></li>
            <li><Link to="/gebaeudeautomation" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.automation")}</Link></li>
            <li><Link to="/wohnanlagen" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.residential")}</Link></li>
            <li><Link to="/service" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.service")}</Link></li>
            <li><Link to="/produktfinder" className="text-white/80 hover:text-[#5FA637] transition-colors">Produktfinder</Link></li>
            <li><Link to="/energie-rechner" className="text-white/80 hover:text-[#5FA637] transition-colors">Energie-Rechner</Link></li>
            <li><Link to="/shop" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.products")}</Link></li>
            <li><Link to="/unternehmen" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.company")}</Link></li>
            <li><Link to="/kontakt" className="text-white/80 hover:text-[#5FA637] transition-colors">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        {/* Contact column */}
        <div className="md:col-span-4">
          <div className="eyebrow mb-5">{t("footer.contact")}</div>
          <ul className="space-y-4 text-sm text-white/80">
            <li>
              <div className="text-white/50 text-xs mb-1">{t("footer.gf")}</div>
              Johannes Fernberg
            </li>
            <li>
              <div className="text-white/50 text-xs mb-1">{t("footer.address")}</div>
              ECO BUILDING TECHNIK GMBH<br/>
              Seepromenade 109<br/>
              AT-2384 Ebreichsdorf
            </li>
            <li>
              <div className="text-white/50 text-xs mb-1">{t("footer.mobile")}</div>
              <a href="tel:+436643289599" className="hover:text-[#5FA637] transition-colors">+43 664 328 95 99</a>
            </li>
            <li>
              <div className="text-white/50 text-xs mb-1">E-Mail</div>
              <a href="mailto:office@eco-building.tech" className="hover:text-[#5FA637] transition-colors">office@eco-building.tech</a>
            </li>
            <li>
              <div className="text-white/50 text-xs mb-1">{t("footer.web")}</div>
              <a href="https://eco-gebaeudetechnik.com" target="_blank" rel="noreferrer" className="hover:text-[#5FA637] transition-colors">eco-gebaeudetechnik.com</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="site-container py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-[10px] tracking-[0.12em] uppercase text-white/45 font-medium">
          <span>© {new Date().getFullYear()} ECO BUILDING TECHNIK GMBH — {t("footer.copyright")}</span>
          <div className="flex items-center gap-6">
            <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-impressum">{t("footer.impressum")}</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-datenschutz">{t("footer.privacy")}</Link>
            <Link to="/agb" className="hover:text-white transition-colors" data-testid="footer-agb">{t("footer.terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
